/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Newsletter_ConsentInputs */

const en_newsletter_consent = /** @type {((inputs: Newsletter_ConsentInputs) => LocalizedString) & { parts: (inputs: Newsletter_ConsentInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Newsletter_ConsentInputs) => LocalizedString} */ (() => {
			return /** @type {LocalizedString} */ (`Send me occasional updates. Unsubscribe at any time. See our privacy policy.`)
		}),
		{
			parts: /** @type {(inputs: Newsletter_ConsentInputs) => import('../runtime.js').MessagePart[]} */ (() => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "text", value: "Send me occasional updates. Unsubscribe at any time. See our " }, { type: "markup-start", name: "link", options: {}, attributes: {} }, { type: "text", value: "privacy policy" }, { type: "markup-end", name: "link", options: {}, attributes: {} }, { type: "text", value: "." }])
			})
		}
	)
);

const zh_newsletter_consent = /** @type {((inputs: Newsletter_ConsentInputs) => LocalizedString) & { parts: (inputs: Newsletter_ConsentInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Newsletter_ConsentInputs) => LocalizedString} */ (() => {
			return /** @type {LocalizedString} */ (`不定期向我发送最新动态，可随时退订。详见我们的隐私政策。`)
		}),
		{
			parts: /** @type {(inputs: Newsletter_ConsentInputs) => import('../runtime.js').MessagePart[]} */ (() => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "text", value: "不定期向我发送最新动态，可随时退订。详见我们的" }, { type: "markup-start", name: "link", options: {}, attributes: {} }, { type: "text", value: "隐私政策" }, { type: "markup-end", name: "link", options: {}, attributes: {} }, { type: "text", value: "。" }])
			})
		}
	)
);

/**
* | output |
* | --- |
* | "Send me occasional updates. Unsubscribe at any time. See our privacy policy." |
*
* @param {Newsletter_ConsentInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const newsletter_consent = /** @type {((inputs?: Newsletter_ConsentInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & { parts: (inputs?: Newsletter_ConsentInputs, options?: { locale?: "en" | "zh" }) => import('../runtime.js').MessagePart[] } & import('../runtime.js').MessageMetadata<Newsletter_ConsentInputs, { locale?: "en" | "zh" }, { link: { options: {}; attributes: {}; children: true } }>} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs?: Newsletter_ConsentInputs, options?: { locale?: "en" | "zh" }) => LocalizedString} */ ((inputs = {}, options = {}) => {
			const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
			if (locale === "zh") return zh_newsletter_consent(inputs)
			return en_newsletter_consent(inputs)
		}),
		{
			parts: /** @type {(inputs?: Newsletter_ConsentInputs, options?: { locale?: "en" | "zh" }) => import('../runtime.js').MessagePart[]} */ ((inputs = {}, options = {}) => {
				const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
				if (locale === "zh") return /** @type {{ parts?: (inputs: Newsletter_ConsentInputs) => import('../runtime.js').MessagePart[] }} */ (zh_newsletter_consent).parts?.(inputs) ?? [{ type: "text", value: zh_newsletter_consent(inputs) }]
				return /** @type {{ parts?: (inputs: Newsletter_ConsentInputs) => import('../runtime.js').MessagePart[] }} */ (en_newsletter_consent).parts?.(inputs) ?? [{ type: "text", value: en_newsletter_consent(inputs) }]
			})
		}
	)
);